var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('screen',{staticClass:"login-view",attrs:{"size":"small"}},[_c('template',{slot:"body"},[_c('div',{staticClass:"login-header"},[_c('div',{staticClass:"roundup-logo"})])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }